// import { getFetchMock } from './mocks/fetch';
import { FacilityAddData, FacilityUpdateData } from '@libs/models/facilities';
import { request } from '../request';

export async function activateFacility(id: string): Promise<void> {
  const response = await request.post(`/facilities/activate/${id}`);
}

export async function deactivateFacility(id: string): Promise<void> {
  const response = await request.post(`/facilities/activate/${id}`);
}

export async function addFacility(entity: FacilityAddData): Promise<void> {
  const response = await request.post(`/facilities`, {
    ...entity,
    facilityName: entity.name,
    facilityTypes: entity.linesOfBusiness,
    address: {
      addressLine1: entity.address.addressFirst,
      addressLine2: entity.address.addressSecond,
      city: entity.address.city,
      state: entity.address.state,
      zipCode: entity.address.zipCode,
    },
  } as ServerFacilityAddData);
}

export async function updateFacility(entity: FacilityUpdateData): Promise<void> {
  const response = await request.post(`/facilities/${entity.id}`, {
    ...entity,
    facilityName: entity.name,
    facilityTypes: entity.linesOfBusiness,
    address: {
      addressLine1: entity.address.addressFirst,
      addressLine2: entity.address.addressSecond,
      city: entity.address.city,
      state: entity.address.state,
      zipCode: entity.address.zipCode,
    },
  } as ServerFacilityAddData);
}

type ServerFacilityAddData = {
  facilityName: string;
  domainName: string;
  facilityTypes: string[];
  numberOfEmployees: {
    minValue: number;
    maxValue: number;
  };
  contact: {
    email: string;
    firstName: string;
    phoneNumber: string;
    lastName: string;
  };
  address: {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
  };
};
